// extracted by mini-css-extract-plugin
export var bottomLogos = "homepageSocialProof-module--bottomLogos--f6c83";
export var bottomRow = "homepageSocialProof-module--bottomRow--17937";
export var caption = "homepageSocialProof-module--caption--edec5";
export var container = "homepageSocialProof-module--container--41ebb";
export var g2 = "homepageSocialProof-module--g2--d4b97";
export var headline = "homepageSocialProof-module--headline--8f74d";
export var logorow = "homepageSocialProof-module--logorow--8ec73";
export var marquee = "homepageSocialProof-module--marquee--14e72";
export var ratings = "homepageSocialProof-module--ratings--cb3cd";
export var topRow = "homepageSocialProof-module--topRow--b2c98";